const zh_CN = {
  'hello': 'Hello',
  "App.Footer.noteText": "The exact train location could be different from the displayed one",
  "App.Train.significantlyDelayed": "大幅延迟",
  "App.ModalDialog.headerTitle": "列车信息",
  "App.ModalDialog.cars": "节",
  "App.ModalDialog.currently": "当前位置",
  "App.ModalDialog.onTime": "准点",
  "App.ModalDialog.minLate": "分钟",
  "App.ModalDialog.significantlyDelayed": "大幅延迟",
  "App.ModalDialog.trainStops": "停车站",
  "App.ModalDialog.arrivesScheduled": "到达时间（正点）",
  "App.ModalDialog.estimated": "（预计）",
  "App.ModalDialog.doesNotStop": "经过",
  "App.ModalDialog.sorryArrivalTimeNotAvailable": "非常抱歉。\r\n现在无法显示到达时间。",
  "App.ModalDialog.arrivalTimeNotAvailable": "现在无法显示到达时间。",
  "App.ModalDialog.furtherArrivalTimeNotAvailable": "现在无法显示到达时间。",
  "App.ModalDialog.kindOrDestinationsMayChange": "注：车型、目的地等有变更的可能性。",
  "App.TrainPositions.enableAutoRefresh": "打开自动更新",
  "App.TrainPositions.disableAutoRefresh": "关闭自动更新",
  "App.TrainPositions.thruToJR": "直达埼京线・{br}川越线",
  "App.TrainPositions.thruToTokyu": "直达东横线・目黑线",
  "App.TrainPositions.thruToToyoko": "直达东横线",
  "App.TrainPositions.thruToMeguro": "直达目黑线",
  "App.TrainPositions.thruToFukutoshin": "直达副都心线",
  "App.TrainPositions.thruToNambokuMita": "直达南北线・三田线",
  "App.TrainPositions.kindModal.title": "凡例",
  "App.TrainPositions.footer.actualMayDiffer": "可能与实际的列车位置、车型、目的地、车厢数量、延迟时间不同。",
  "App.TrainPositions.footer.displayTime": "画面显示时间",
  "App.TrainPositions.dialog.outsideArea": "非相铁线服务区",  
  "App.RouteMap.kindModal.title": "凡例",
  "App.RouteMap.kindModal.noteComLtdExpAndComExpStops": "○：通勤特快・通勤直达停车站",
  "App.RouteMap.kindModal.noteComLtdExpStops": "△：通勤特快车停在鹤峰",
  "App.TransferModal.transferRoute": "换乘线路",
  "StationDetail.stationMap": "车站布置图",
  "StationDetail.stopPositions": "列车停靠位置",
  "StationDetail.thruToJR": "直达埼京线・川越线",
  "StationDetail.thruToToyoko": "直达东横线",
  "StationDetail.thruToMeguro": "直达目黑线",
  "StationDetail.checkCongestionSituation": "可以确认车站的{br}拥挤情况",
  "StationDetail.stationView": "车站景观",
  "Timetable.trackNo": "站台",
  "Timetable.trainKind": "车型",
  "Timetable.destination": "目的地",
  "Timetable.depTime": "发车时间",
  "Timetable.cars": "车厢",
  "TermsDetail.pageTitle": "相铁应用程序服务条款",
  "TermsDetail.title": "前言",
  "TermsDetail.abstract": "“相铁应用程序”（以下称“本应用程序”）是相模铁路株式会社（以下称“相模铁路”）提供的智能手机应用程序。《相铁应用程序服务条款》（以下称“本条款”）规定了相模铁路对本应用程序用户（以下称“用户”）的提供条件，以及用户与相模铁路之间关于使用本应用程序的权利义务。",
  "TermsDetail.article1": "第1条 条款的适用",
  "TermsDetail.paragraph1_1": "用户应在同意本条款的前提下使用本应用程序。如果不同意本条款，则不得使用本应用程序。",
  "TermsDetail.paragraph1_2": "本条款规定了本应用程序的提供条件，以及用户与相模铁路之间关于使用本应用程序的权利义务，适用于用户与相模铁路之间关于使用本应用程序的一切关系。",
  "TermsDetail.paragraph1_3": "如果本条款内容与本应用程序除本条款外的其他说明有所不同，则优先适用本条款。",
  "TermsDetail.article2": "第2条 本应用程序的目的",
  "TermsDetail.paragraph2_1": "本应用程序旨在通过互联网提供相模铁路的运行信息和相模铁路（包括集团公司）的活动信息等。",
  "TermsDetail.article3": "第3条 使用费",
  "TermsDetail.paragraph3_1": "本应用程序免费提供，但下载和使用本应用程序所产生的通讯费由用户承担。",
  "TermsDetail.article4": "第4条 使用环境",
  "TermsDetail.paragraph4_1": "使用本应用程序所需的设备、软件、互联网连接、电话线路等，由用户负责准备并承担费用。",
  "TermsDetail.article5": "第5条 知识产权",
  "TermsDetail.paragraph5_1": "与本应用程序内容有关的著作权和其他知识产权均归属于相模铁路或其指定方。",
  "TermsDetail.article6": "第6条 本应用程序的变更及终止",
  "TermsDetail.paragraph6_1": "相模铁路可以在不事先通知的情况下更改、添加或删除本应用程序的全部或部分内容。",
  "TermsDetail.paragraph6_2": "相模铁路可以在不事先通知的情况下终止提供、更新本应用程序。",
  "TermsDetail.article7": "第7条 免责事项",
  "TermsDetail.paragraph7_1": "相模铁路不对用户保证本应用程序能够正常运行，也不保证所有功能均起作用。",
  "TermsDetail.paragraph7_2": "相模铁路通过本应用程序尽量提供准确的信息，但不保证信息的准确性和完整性。并且，由于互联网的特性，本应用程序中的信息与真实信息可能存在时间差等。",
  "TermsDetail.paragraph7_3": "如果符合下列任一情况，相模铁路可以在不事先通知用户的情况下，停止或中断提供本应用程序的全部或部分内容：",
  "TermsDetail.paragraph7_3_1": "对系统进行紧急检查或紧急维护；",
  "TermsDetail.paragraph7_3_2": "计算机、通讯线路等因事故或第三方攻击而停止运作；",
  "TermsDetail.paragraph7_3_3": "地震、闪电、火灾等不可抗力造成本应用程序无法运营；",
  "TermsDetail.paragraph7_3_4": "相模铁路用于运营本应用程序的设施等，因电信服务或互联网供应商的原因处于无法通讯的状态；",
  "TermsDetail.paragraph7_3_5": "相模铁路认为有必要停止或中断提供本应用程序的其他情况。",
  "TermsDetail.paragraph7_4": "对于因用户使用本应用程序，或因本应用程序无法使用而对用户或第三方造成的损害，相模铁路不负任何责任。",
  "TermsDetail.article8": "第8条 禁止事项",
  "TermsDetail.paragraph8_1": "1.  使用本应用程序时，禁止作出下列行为（包括引发下列行为的行为和预备行为）：",
  "TermsDetail.paragraph8_1_1": "冒充相模铁路或第三方的行为（冒充行为）；",
  "TermsDetail.paragraph8_1_2": "在著作权法允许的私人使用范围之外，对本应用程序发送的影像、音频、字符等、软件、以及本应用程序的相关信息进行转载、复印、复制、出版、放映、转让、改变、公开传输、可传输化，或以其他形式使用的行为，以及其他一切二次使用行为；",
  "TermsDetail.paragraph8_1_3": "通过反编译、反汇编、逆向工程，分析或改变本应用程序的源代码、结构和规格的行为；",
  "TermsDetail.paragraph8_1_4": "将涉及本应用程序的全部或部分权利和义务转让、出租或转移给第三方的行为；",
  "TermsDetail.paragraph8_1_5": "非法访问相模铁路或第三方的通讯设备、计算机和其他设备及软件，或影响其使用或运用的行为，或有这种可能性的行为；",
  "TermsDetail.paragraph8_1_6": "侵犯或有可能侵犯相模铁路或第三方的知识产权和其他权利的行为；",
  "TermsDetail.paragraph8_1_7": "违反或有可能违反公序良俗的行为，违法或有可能违法的行为；",
  "TermsDetail.paragraph8_1_8": "选举活动或其类似行为，其他与政治、宗教有关的行为；",
  "TermsDetail.paragraph8_1_9": "将违反或有可能违反事实的信息提供给相模铁路、其他用户或第三方的行为；",
  "TermsDetail.paragraph8_1_10": "与本应用程序相关的盈利行为，或为其做准备的行为；",
  "TermsDetail.paragraph8_1_11": "对本应用程序的提供和运营进行阻碍或诽谤的行为；",
  "TermsDetail.paragraph8_1_12": "收集、积攒其他用户相关信息的行为；",
  "TermsDetail.paragraph8_1_13": "通过与本应用程序相关的方式，直接或间接向下一条规定的反社会势力或与其有密切联系者提供利益的行为；",
  "TermsDetail.paragraph8_1_14": "妨碍本应用程序运营的行为，或相模铁路认为不当的行为。",
  "TermsDetail.paragraph8_2": "2.  如果用户作出符合前款禁止事项的行为，相模铁路可能会停止该用户对本应用程序的使用。并且，对于停止该用户使用本应用程序，本公司不负任何责任。",
  "TermsDetail.article9": "第9条 清除反社会势力",
  "TermsDetail.paragraph9_1": "使用本应用程序之前，用户应向相模铁路表明并保证自己并非暴力团成员，亦非与暴力团有关的企业、团体、其他反社会势力或其相关人员。",
  "TermsDetail.article10": "第10条 历史信息的获取",
  "TermsDetail.paragraph10_1": "相模铁路不会通过本应用程序获取移动终端的个体识别信息（识别个人及终端的信息等）。",
  "TermsDetail.paragraph10_2": "相模铁路会向用户收集如下信息（以下称“历史信息”），用于改良本应用程序和提高其便利性、研究探讨与本应用程序相关的新服务、推荐本应用程序相关内容（推荐服务）：",
  "TermsDetail.paragraph10_2_1": "本应用程序的使用日期和时间；",
  "TermsDetail.paragraph10_2_2": "本应用程序的使用方法；",
  "TermsDetail.paragraph10_2_3": "本应用程序的使用环境（使用本应用程序的位置信息、OS种类及版本、浏览器种类、移动设备的机型、cookie和JavaScript设为ON等信息）。",
  "TermsDetail.paragraph10_3": "相模铁路会将历史信息处理成统计数据，并将其提供给相铁集团各公司及合作公司。",
  "TermsDetail.article11": "第11条 关于My车站",
  "TermsDetail.paragraph11_1": "用户须注册My车站方能使用本应用程序的部分功能。",
  "TermsDetail.paragraph11_2": "注册My车站的用户随时可以更改、删除My车站中注册的信息。",
  "TermsDetail.article12": "第12条 个人信息的处理",
  "TermsDetail.paragraph12_1": "用户向相模铁路提供个人信息时，在处理个人信息方面，除本条款外，相铁集团网站上登载的《{groupPolicyLink}》也将得到适用。",
  "TermsDetail.paragraph12_1_group_policy": "相铁集团个人信息保护方针",
  "TermsDetail.paragraph12_2": "相模铁路委托外部管理本条款所规定信息的信息系统，同时将个人信息交给受托方保管。相模铁路负责监督受托方妥善保护和管理用户的个人信息。",
  "TermsDetail.paragraph12_3": "在第15条规定的定期票QR预订系统中注册的个人信息，通过使用服务器ID和SSL的加密通信，将安全地传输到相模铁道的服务器。此外，根据顾客所使用的智能手机或平板电脑的环境，未加密的个人信息作为缓存数据可能被保存到智能手机或平板电脑。输入个人信息后，请谨慎使用信息终端设备。",
  "TermsDetail.article13": "第13条 关于推送通知功能",
  "TermsDetail.paragraph13_1": "本应用程序具备推送通知功能（需要在本应用程序中通知用户时，应用程序自动进行通知的功能）。用户如要使用推送通知功能，请在设置画面将推送通知功能设为ON。该设置随时可以更改。",
  "TermsDetail.paragraph13_2": "相模铁路会以第10条第2款规定的目的，使用关于推送通知功能的用户历史信息。",
  "TermsDetail.article14": "第14条 关于车站景观",
  "TermsDetail.paragraph14_1": "本应用程序具备车站景观功能（发送车站拥挤情况的图像）。从保护个人信息的观点出发，相模铁路在车站内设置了应用程序专用摄像机，并将其拍摄的图像用数据加工技术进行分析，再为无人的检票口图像（背景图像）配上人形图标，把拥挤情况的图像数据作为匿名信息发送至相铁应用程序。此外，相模铁路不对图像作任何保存。",
  "TermsDetail.article15": "第15条 关于定期票QR预订系统",
  "TermsDetail.paragraph15_1": "本应用程序链接至定期票QR预订系统（下称“本服务”）。在本服务预订完成的同时，相铁线应用程序将发送推送通知。通知内容包含购票时所需的二维码，请将信息终端设备设为可接收推送通知进行使用。",
  "TermsDetail.paragraph15_2": "使用本服务的顾客将被视为同意预订定期票时显示的注意事项“本服务的使用”以及公布于本公司官方网站的“定期票的使用说明”的内容。",
  "TermsDetail.article16": "第16条 受支持的OS",
  "TermsDetail.paragraph16_1": "相铁应用程序支持的OS如下。此外，受支持的OS也有部分无法运行的情况。",
  "TermsDetail.paragraph16_1_ios": "iOS 10或更新版本",
  "TermsDetail.paragraph16_1_android": "Android 5或更新版本",
  "TermsDetail.article17": "第17条 本条款的变更",
  "TermsDetail.paragraph17_1": "相模铁路可以在未经用户同意、不事先通知的情况下更改本条款内容。如有变更，相模铁路会将这一通知显示在本应用程序画面上。通知显示后，如果用户使用本应用程序，将视为用户同意变更后的条款。如果用户无法同意变更后的本条款，则必须立即停止使用本应用程序。",
  "TermsDetail.article18": "第18条 适用法律及协议管辖",
  "TermsDetail.paragraph18_1": "对本应用程序的使用和对本条款的解释，均遵照日本国法律。与本应用程序有关的诉讼，以横滨地方法院为第一审的专属协议管辖法院。",
  "TermsDetail.signatureName": "相模铁路株式会社",
  "TermsDetail.signatureDate": "2020年3月18日（修订）",
  "ContactDetail.title": "与相铁有关的咨询、意见和要求",
  "ContactDetail.body1": "相铁客服中心",
  "ContactDetail.body2": "TEL 045-319-2111 9:00—19:00（周六、周日及节假日为9:00—17:00，12月30日至1月3日停止营业）",
  "ContactDetail.body3": "FAX 045-319-2191",
  "ContactDetail.footer1": "详情请轻点",
  "ContactDetail.footerHere": "此处",
  "ContactDetail.footer2": "查看。",

  // titles for navite app
  "PageTitle.StationDetail": '车站信息',
  "PageTitle.StationView": '车站景观',
  "PageTitle.TrainPositions": '列车行驶位置',
  "PageTitle.RouteMap": '线路图',
}

export default zh_CN
